import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineFormulationDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineFormulation/GetDetail?` + params, null);

export const GetMedicineFormulationList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineFormulation/GetList?` + params, null);

export const CreateMedicineFormulation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineFormulation/Create`, data);

export const UpdateMedicineFormulation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineFormulation/Update`, data);

export const DeleteMedicineFormulation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineFormulation/Delete`, data);






